import React from "react"
import { Flex, Text, VStack } from "@chakra-ui/react"
import { useIntercom } from "react-use-intercom"
import Button from "components/Buttons/Button"
import Icon from "components/elements/Icon"
import Link from "components/elements/Link"

type Props = {
  onRetry: () => void
}

// Fallback for one page or event tab. It fills the page area only, so the
// app's navigation stays on screen and the user can move on to another page.
// Text, not Heading: the theme sets only the body font, so Heading would
// fall back to the system font.
const PageErrorView = ({ onRetry }: Props) => {
  const { show: showIntercom } = useIntercom()

  return (
    <Flex role="alert" flex={1} minH="100vh" direction="column" justify="center" align="center" p={8} textAlign="center">
      <VStack spacing={4} maxW={420}>
        <Flex w={12} h={12} borderRadius="full" bg="gray.100" align="center" justify="center">
          <Icon icon="alert" color="gray.500" size={6} />
        </Flex>
        <VStack spacing={2}>
          <Text fontSize="xl" fontWeight="semibold" lineHeight="1.2">
            Something went wrong
          </Text>
          <Text color="gray.600">
            This page couldn’t be displayed. We’ve been notified and will work to quickly resolve.
          </Text>
        </VStack>
        <Button variant="outline" size="sm" onClick={onRetry}>Try again</Button>
        <Text fontSize="sm" color="gray.500">
          If the error persists, please{" "}
          <Link as="button" type="button" onClick={showIntercom}>contact us</Link>.
        </Text>
      </VStack>
    </Flex>
  )
}

export default PageErrorView
